export enum FeatureFlag {
  // Features
  SHOW_FLAGS_LINK = "showFlagsLink",
  VIRTUAL_DEVICES = "virtualDevices",
  SHOW_OUTDOOR_MOTION_GRAPH = "showOutdoorMotionGraph",
  SHOW_ICM_ANALYTICS = "showIcmAnalytics",
  OAUTH = "oauthEnabled",
  SEAL_AUTH = "sealAuth",
  SHOW_HOME_DETAIL_BETA_TOGGLE = "showHomeDetailBetaToggle",
  SHOW_NEW_HOME_DETAILS_VIEW = "showNewHomeDetailsView",
  SHOW_HOME_DETAILS_V3 = "showHomeDetailsV3",
  HOME_DETAILS_REVAMP = "homeDetailsRevamp",
  DASHBOARD_REVAMP = "dashboardRevamp",
  HOME_LIST_WIDGETS = "homeListWidgets",
  MINUT_EMPLOYEE = "minutEmployee",
  EXPORT_SENSOR_VALUES_FULL_RESOLUTION = "exportSensorValuesFullResolution",
  SHOW_PM25_GRAPH = "showPm25Graph",
  SHOW_FUNCTIONALITY_TABLE = "showFunctionalityTable",
  SHOW_CHART_SERIES_ZONES = "showChartSeriesZones",
  SPLIT_INDOOR_CLIMATE_CHART = "splitIndoorClimateChart",
  INTEGRATION_AUTOLINK = "integrationAutolink",
  SHOW_BATTERY_PERCENT = "showBatteryPercent",
  RESERVATIONS_SETUP_HINTS = "reservationsSetupHints",
  RESERVATIONS_CALENDAR = "reservationsCalendar",
  RESIDENTIAL = "residential",

  // Dev
  DEBUG = "debug", // Generic flag for toggling debugging
  HOME_DETAILS_SIMULATIONS = "homeDetailsSimulations",
  BETA = "beta", // Generic flag for features ready for testing
  REACT_QUERY_DEVTOOLS_PROD = "reactQueryDevToolsProd",
  USE_MOCK_DATA = "useMockData",
  INSTALL_DEVICE = "installDevice",
  LOGOUT_DEBUGGER = "logoutDebugger",
  PSEUDO_TRANSLATIONS = "pseudoTranslations",

  // Logging
  LOGGING_STORAGE_DEFAULT = "loggingStorageDefault",
  LOGGING_DEBUG = "loggingDebugDefault",
  LOGGING_ROUTER = "loggingRouter",
  LOGGING_ANALYTICS = "loggingAnalytics",
  LOGGING_SENTRY_CAPTURE_CONSOLE = "loggingSentryCaptureConsole",
}
